/**
 * tailwind plugins was written using extend configuration feature. It was used to give our modal sizes into the existing config.

 * ? https://tailwindcss.com/docs/plugins#extending-the-configuration
 */
import plugin from 'tailwindcss/plugin'

export default plugin(
  ({ matchUtilities, theme }) => {
    matchUtilities(
      {
        layout: (value) => ({
          maxWidth: value,
          width: '100%',
          margin: '0 auto',
        }),
      },
      { values: theme('layout') },
    )
  },
  {
    theme: {
      layout: {
        document: '800px',
        'side-bar': '1920px',
      },
    },
  },
)
